export default {
    // 判断机器人微信客服独立版
    WXKF_ROBOT_URL: /(\/tp\/wpaWxStandalone)/,
    // 判断机器人微信客服视频号独立版
    WXKF_ROBOTSPH_URL: /(\/tp\/wpaWxSphStandalone)/,
    // 微信客服接入首页URL
    WPAWX_URL: '/tp/wpaWx',
    // 机器人独立版微信客服首页URL
    WPAWX_STANDALONE_URL: '/tp/wpaWxStandalone',
    // 微信客服接入编辑页URL
    WPAWX_EDIT_URL: '/tp/wpaWx/edit',
    // 微信客服独立版编辑页面
    WPAWX_EDIT_STANDALONE_URL: '/tp/wpaWxStandalone/edit',
    // 微信客服视频号编辑页面
    WPAWX_SPH_URL: '/tp/wpaWxSph/edit',
    // 微信客服视频号独立版编辑页面
    WPAWX_SPH_STANDALONE_URL: '/tp/wpaWxSphStandalone/edit',
    // 指定回到微信视频号
    WPAWX_RIRECT_URL: '/tp/wpaWx?selected=wpaWxSph',
    // 指定回到独立版微信视频号
    WPAWX_RIRECT_STANDALONE_URL: '/tp/wpaWxStandalone?selected=wpaWxSph',
};
